var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLoyaltyCalendar = function SvgIconLoyaltyCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgba(255,255,255,0)",
    stroke: "#061e21",
    "data-name": "Ellipse 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#061e21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.125 16.104a.52.52 0 0 1 .521-.521h1.042a.52.52 0 0 1 .521.521v1.041a.52.52 0 0 1-.521.521h-1.042a.52.52 0 0 1-.521-.521Z",
    "data-name": "Path 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.313 9.333a.52.52 0 0 1 .521.521v.521h8.333v-.521a.521.521 0 1 1 1.042 0v.521h1.041a2.083 2.083 0 0 1 2.083 2.083v11.458a2.083 2.083 0 0 1-2.083 2.083h-12.5a2.083 2.083 0 0 1-2.083-2.083V12.458a2.083 2.083 0 0 1 2.083-2.084h1.042v-.52a.52.52 0 0 1 .521-.521m-2.6 4.167v10.416a1.04 1.04 0 0 0 1.037 1.042h12.5a1.04 1.04 0 0 0 1.042-1.042V13.499Z",
    "data-name": "Path 2"
  }))));
};
export default SvgIconLoyaltyCalendar;